import ServiceScriptProvider, { ServiceScript } from "providers/ServicesProvider/ServiceScriptProvider";
import scraperApi from "api";


export const CHATBASE_SERVICE_SCRIPT: ServiceScript = {
  name: "Chatbase AI Chatbot Script",
  domId: "chatbase-init-script",
  src: "./chatbaseInit.js",
  onLoadCallback: () => {
    // get identity token from backend
    scraperApi.chatbase.identityToken()
      .then(identityToken => window.chatbase("identify", { token: identityToken }));
  }
};

export default function ChatbaseScript() {
  if (process.env.REACT_APP_SUPPORT_WIDGET_USE === "chatbase") {
    return <ServiceScriptProvider { ...CHATBASE_SERVICE_SCRIPT } />;
  } else {
    return <></>;
  }
}
